import ReactDOM from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import { AuthProvider } from './context/AuthContext';
import './index.css';
import { WSProvider } from './context/WebSocketContext';

ReactDOM.render(
  <HelmetProvider>

    <BrowserRouter basename={process.env.REACT_APP_BASE_NAME}>
      <WSProvider>
        <AuthProvider>
        <App />
        </AuthProvider>
      </WSProvider>
    </BrowserRouter>
  </HelmetProvider>,
  document.getElementById('root')
);
